import React from "react";
import { MdClose, MdCalendarToday, MdNotes, MdPerson } from "react-icons/md";

const EventModal = ({ event, onClose }) => {
    if (!event) return null;

    // Format date and time
    const formattedDate = event.date.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    const formattedTime = event.time.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    // Determine badge color based on type
    const typeBadge = event.type === "lead" ? "bg-blue-100 text-blue-800" : "bg-purple-100 text-purple-800";
    const typeLabel = event.type === "lead" ? "Lead" : "Client";

    // Status badge color
    const statusColor =
        event.status === "scheduled"
            ? "bg-green-100 text-green-800"
            : event.status === "completed"
                ? "bg-gray-100 text-gray-800"
                : "bg-yellow-100 text-yellow-800";

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full max-h-96 overflow-y-auto">
                {/* Header */}
                <div className="sticky top-0 flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
                    <div>
                        <h3 className="text-xl font-bold text-navy-700 dark:text-white">
                            {event.name}
                        </h3>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                            {typeLabel} Schedule
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-200"
                    >
                        <MdClose className="h-6 w-6 text-navy-700 dark:text-white" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6 space-y-4">
                    {/* Type Badge */}
                    <div className="flex items-center gap-2">
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${typeBadge}`}>
                            {typeLabel}
                        </span>
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold capitalize ${statusColor}`}>
                            {event.status}
                        </span>
                    </div>

                    {/* Date & Time */}
                    <div className="flex items-start gap-3 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                        <MdCalendarToday className="h-5 w-5 text-brand-500 flex-shrink-0 mt-0.5" />
                        <div>
                            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
                                Scheduled Date & Time
                            </p>
                            <p className="text-base font-semibold text-navy-700 dark:text-white mt-1">
                                {formattedDate}
                            </p>
                            <p className="text-base font-semibold text-navy-700 dark:text-white">
                                {formattedTime}
                            </p>
                        </div>
                    </div>

                                    {/* Care Of */}
                    {event.careOf && (
                        <div className="flex items-center gap-3">
                            <MdPerson className="h-5 w-5 text-brand-500 flex-shrink-0" />
                            <div>
                                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
                                    Care Of
                                </p>
                                <p className="text-base font-semibold text-navy-700 dark:text-white">
                                    {event.careOf}
                                </p>
                            </div>
                        </div>
                    )}

                    {/* Notes */}
                    {event.note && (
                        <div className="flex items-start gap-3">
                            <MdNotes className="h-5 w-5 text-brand-500 flex-shrink-0 mt-0.5" />
                            <div>
                                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
                                    Notes
                                </p>
                                <p className="text-base text-navy-700 dark:text-white mt-1 break-words">
                                    {event.note}
                                </p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer - Close Button */}
                <div className="sticky bottom-0 p-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700">
                    <button
                        onClick={onClose}
                        className="w-full px-4 py-2 bg-brand-500 text-white rounded-lg hover:bg-brand-600 transition-all duration-200 font-medium"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EventModal;
